import { formatPrice } from '../../utils/timedPlayConfig';
import {
  formatStakingLabel,
  parsePerpetualPlayConfig,
} from '../../utils/perpetualPlayConfig';

export default function PerpetualEntrustmentCard({
  order,
  product,
  currentPrice,
  cancelling = false,
  onCancel,
  onEditTpSl,
}) {
  if (!order) {
    return null;
  }

  const playConfig = parsePerpetualPlayConfig(product?.playConfig);
  const isLong = order.orderType === 'LONG';
  const pairLabel = product?.name || `${order.marketSymbolCode || ''}/USDT 永續`;

  return (
    <li className="perpetual-position-card perpetual-entrustment-card">
      <div className="perpetual-position-card__head">
        <span className={`perpetual-position-card__badge ${isLong ? 'is-up' : 'is-down'}`}>
          {isLong ? '做多' : '做空'}
        </span>
        <strong>{pairLabel}</strong>
        <span className="perpetual-position-card__status">委託中</span>
      </div>

      <div className="perpetual-position-card__grid">
        <div>
          <span>鎖倉期限</span>
          <strong>{formatStakingLabel(playConfig.stakingTimeDays)}</strong>
        </div>
        <div>
          <span>下單金額</span>
          <strong>{formatPrice(order.betAmount, 6)}</strong>
        </div>
        <div>
          <span>委託價</span>
          <strong>{formatPrice(order.orderPrice, 4)}</strong>
        </div>
        <div>
          <span>最新價格</span>
          <strong>{formatPrice(currentPrice, 4)}</strong>
        </div>
        <div>
          <span>槓桿</span>
          <strong>X{order.contractMultiple}</strong>
        </div>
        <div>
          <span>保證金</span>
          <strong>{formatPrice(order.margin, 6)}</strong>
        </div>
        <div>
          <span>止盈</span>
          <strong>{order.takeProfitPrice ? formatPrice(order.takeProfitPrice, 4) : '—'}</strong>
        </div>
        <div>
          <span>止損</span>
          <strong>{order.stopLossPrice ? formatPrice(order.stopLossPrice, 4) : '—'}</strong>
        </div>
        <div>
          <span>手續費</span>
          <strong>{formatPrice(order.fee, 6)}</strong>
        </div>
      </div>

      <div className="perpetual-position-card__footer">
        <span>{order.createTime || '—'}</span>
        <div className="perpetual-position-card__actions">
          <button type="button" onClick={() => onEditTpSl?.(order)}>
            止盈止損
          </button>
          <button
            type="button"
            disabled={cancelling}
            onClick={() => onCancel?.(order)}
          >
            {cancelling ? '撤單中…' : '撤單'}
          </button>
        </div>
      </div>
    </li>
  );
}
